import * as React from 'react';
import { useForm } from "react-hook-form";
import type { SubmitHandler } from "react-hook-form";

import Button from '../Button/Button';
import SubmitButton from '../SubmitButton/SubmitButton';

import type { Expense } from '../../types/Expense';

type Input = {
    name: string;
    amount: string;
    repeats: boolean;
    date: string;
};

type ExpenseRowProps = {
    expense: Expense, 
    index: number, 
    remove: (index: number) => void
};

function ExpenseRow({expense, index, remove}: ExpenseRowProps) {
    const [view, setView] = React.useState<boolean>(false);
    const [edit, setEdit] = React.useState<boolean>(false);

    const {
        register,
        handleSubmit,
    } = useForm<Input>();

    const onSubmit: SubmitHandler<Input> = (data: Input) => {
        expense.name = data.name;
        expense.amount = parseFloat(data.amount);
        expense.when.repeats = data.repeats;
        setEdit(false);
    }

    return (
        <div>
            <p>{expense.name}</p>
            <Button callback={() => { setView(true) }}>View</Button>
            <Button callback={() => { setEdit(true) }}>Edit</Button>
            <Button callback={() => { remove(index) }}>Delete</Button>
            {view && (
                <div>
                    <p><span>Name:</span> <span>{expense.name}</span></p>
                    <p><span>Amount:</span> <span>{expense.amount}</span></p>
                    <Button callback={() => { setView(false) }}>Close</Button>
                </div>
            )}
            {edit && (
                <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="name">Name</label>
                        <input id="name" defaultValue={expense.name} {...register("name")} />

                        <label htmlFor="name">Amount</label>
                        <input id="amount" type="number" min={0} step={0.01} defaultValue={expense.amount} {...register("amount")} />

                        <label htmlFor="repeats">Repeats</label>
                        <input id="repeats" type="checkbox" {...register("repeats")} />

                        {/* <label htmlFor="date">Date:</label>
                        <input id="date" type="date" defaultValue={income.when.date} {...register("date")}></input> */}
                        <Button callback={() => { setEdit(false) }}>Cancel</Button>
                        <SubmitButton>Update</SubmitButton>
                    </form>
                </div>
            )}
        </div>
    );
}


export default ExpenseRow;
